import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { FiX } from "react-icons/fi";

interface props {
	title: string | JSX.Element;
	isOpen: boolean;
	closeModal: () => void;
	showCloseButton?: boolean;
	preventDismiss?: boolean;
	children: JSX.Element;
	widthOverrideClass?: string;
	opacityOverrideClass?: string;
	bgColorOverrideClass?: string;
	actionColorsOverrideClass?: string;
	shadowOverrideClass?: string;
	containerOverrideClass?: string;
	removeTitleMargin?: boolean;
}

const Modal: React.FC<props> = ({
	title,
	isOpen,
	closeModal,
	showCloseButton = true,
	preventDismiss = false,
	children,
	widthOverrideClass,
	opacityOverrideClass,
	bgColorOverrideClass,
	actionColorsOverrideClass,
	shadowOverrideClass,
	containerOverrideClass,
	removeTitleMargin,
}) => {
	return (
		<>
			<Transition appear show={isOpen} as={Fragment}>
				<Dialog
					as="div"
					className="fixed inset-0 z-10 overflow-y-auto text-nightSky"
					onClose={preventDismiss ? () => {} : closeModal}
				>
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<div className={`fixed inset-0 bg-black ${opacityOverrideClass || "bg-opacity-25"}`} />
					</Transition.Child>

					<div className="fixed inset-0 overflow-y-auto">
						<div className="flex min-h-full items-center justify-center p-4 text-center">
							<Transition.Child
								as={Fragment}
								enter="ease-out duration-300"
								enterFrom="opacity-0 scale-95"
								enterTo="opacity-100 scale-100"
								leave="ease-in duration-200"
								leaveFrom="opacity-100 scale-100"
								leaveTo="opacity-0 scale-95"
							>
								<Dialog.Panel
									className={`w-full ${widthOverrideClass || "max-w-xl"} transform overflow-hidden rounded  ${
										bgColorOverrideClass || "bg-white"
									} p-6 text-left align-middle ${shadowOverrideClass || "shadow-xl"} transition-all ${
										containerOverrideClass || ""
									}`}
								>
									<div className={`mb-6 ${removeTitleMargin ? "!mb-0" : ""} flex w-full items-center justify-between`}>
										<Dialog.Title
											as="h3"
											className="inline-flex w-full flex-row items-center justify-between  text-lg font-bold leading-6 text-gray-900"
										>
											<span className="inline-block">{title}</span>
										</Dialog.Title>
										<div>
											{showCloseButton && (
												<button
													onClick={closeModal}
													className={`inline-block cursor-pointer ${actionColorsOverrideClass}`}
												>
													<FiX />
												</button>
											)}
										</div>
									</div>
									<div className="mt-2 text-sm text-nightSky">{children}</div>
								</Dialog.Panel>
							</Transition.Child>
						</div>
					</div>
				</Dialog>
			</Transition>
		</>
	);
};

export default Modal;
